import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { GetStockHistoryValue, GetStockHistoryValueDto, StockHistory, StockHistoryEntryDto, StockHistoryMode } from '../models';
import { mapDto } from '@shared/operators';
import { ApiResponse } from '@shared/models';

@Service()
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    getHistory(mode: StockHistoryMode, value: GetStockHistoryValue): Observable<StockHistory> {
        const params = new GetStockHistoryValueDto(value).toHttpParams();
        const url = mode === 'mine' ? 'v1/admin/stock/personal-transfers/history/me' : 'v1/admin/stock/personal-transfers/history';

        return this.httpClient.get<ApiResponse<StockHistoryEntryDto[]>>(url, { params }).pipe(mapDto((response) => new StockHistory(response)));
    }
}
